// СГЕНЕРИРОВАНО scripts/audio/web.mjs (pnpm audio:web) — не править руками.
// Записанные звуки и музыка: design/audio-raw (WAV) → apps/web/public/audio (Opus .ogg + AAC .m4a).

export interface AudioAsset {
  ogg: string;
  m4a: string;
  durationMs: number;
  loop: boolean;
}

export type AudioGroup =
  | 'carp'
  | 'common'
  | 'crash'
  | 'deep'
  | 'doudizhu'
  | 'firecrackers'
  | 'garden'
  | 'hongbao'
  | 'koi-pond'
  | 'mahjong'
  | 'mahjong-table'
  | 'music'
  | 'pot'
  | 'roulette'
  | 'slots'
  | 'spaceport'
  | 'sweet-shop'
  | 'tourney'
  | 'workshop'
  | 'zhajinhua';
/** SFX key `group/key` (music excluded). */
export type SfxKey =
  | 'carp/gate'
  | 'carp/jump'
  | 'carp/rock'
  | 'carp/splash'
  | 'common/achievement'
  | 'common/big'
  | 'common/bonus-open'
  | 'common/boom'
  | 'common/click'
  | 'common/coin'
  | 'common/coins'
  | 'common/error'
  | 'common/flip'
  | 'common/level'
  | 'common/mega'
  | 'common/notify'
  | 'common/pop'
  | 'common/stop'
  | 'common/thud'
  | 'common/tick'
  | 'common/toggle'
  | 'common/win'
  | 'crash/cashout'
  | 'crash/crash'
  | 'crash/engine-loop'
  | 'crash/launch'
  | 'deep/big-win'
  | 'deep/cascade'
  | 'deep/reel-loop'
  | 'deep/reel-stop-1'
  | 'deep/reel-stop-2'
  | 'deep/reel-stop-3'
  | 'deep/scatter'
  | 'deep/theme-stinger'
  | 'deep/win'
  | 'doudizhu/bomb'
  | 'doudizhu/deal'
  | 'doudizhu/pass'
  | 'doudizhu/play-cards'
  | 'doudizhu/rocket'
  | 'doudizhu/spring'
  | 'firecrackers/cleared'
  | 'firecrackers/envelope-open'
  | 'firecrackers/firecracker'
  | 'firecrackers/ingot'
  | 'garden/big-win'
  | 'garden/reel-loop'
  | 'garden/reel-stop-1'
  | 'garden/reel-stop-2'
  | 'garden/reel-stop-3'
  | 'garden/scatter'
  | 'garden/theme-stinger'
  | 'garden/win'
  | 'hongbao/envelope-fly'
  | 'hongbao/envelope-open'
  | 'hongbao/luckiest'
  | 'koi-pond/big-win'
  | 'koi-pond/koi-mult'
  | 'koi-pond/reel-loop'
  | 'koi-pond/reel-stop-1'
  | 'koi-pond/reel-stop-2'
  | 'koi-pond/reel-stop-3'
  | 'koi-pond/scatter'
  | 'koi-pond/theme-stinger'
  | 'koi-pond/win'
  | 'mahjong-table/claim'
  | 'mahjong-table/discard'
  | 'mahjong-table/hu'
  | 'mahjong-table/turn'
  | 'mahjong/hu'
  | 'mahjong/shuffle'
  | 'mahjong/tile-click'
  | 'mahjong/tile-slide'
  | 'pot/wheel-stop'
  | 'pot/wheel-tick'
  | 'pot/winner'
  | 'roulette/green'
  | 'roulette/strip-loop'
  | 'roulette/strip-stop'
  | 'slots/feature-end'
  | 'slots/freespins'
  | 'slots/reel-loop'
  | 'slots/reel-stop-1'
  | 'slots/reel-stop-2'
  | 'slots/reel-stop-3'
  | 'slots/scatter'
  | 'spaceport/big-win'
  | 'spaceport/bonus-buy'
  | 'spaceport/reel-loop'
  | 'spaceport/reel-stop-1'
  | 'spaceport/reel-stop-2'
  | 'spaceport/reel-stop-3'
  | 'spaceport/scatter'
  | 'spaceport/theme-stinger'
  | 'spaceport/win'
  | 'sweet-shop/big-win'
  | 'sweet-shop/jackpot-grand'
  | 'sweet-shop/jackpot-major'
  | 'sweet-shop/jackpot-mini'
  | 'sweet-shop/jar'
  | 'sweet-shop/reel-loop'
  | 'sweet-shop/reel-stop-1'
  | 'sweet-shop/reel-stop-2'
  | 'sweet-shop/reel-stop-3'
  | 'sweet-shop/scatter'
  | 'sweet-shop/theme-stinger'
  | 'sweet-shop/win'
  | 'tourney/seat-ready'
  | 'tourney/stage-up'
  | 'workshop/big-win'
  | 'workshop/progress'
  | 'workshop/reel-loop'
  | 'workshop/reel-stop-1'
  | 'workshop/reel-stop-2'
  | 'workshop/reel-stop-3'
  | 'workshop/scatter'
  | 'workshop/theme-stinger'
  | 'workshop/win'
  | 'zhajinhua/card-flip'
  | 'zhajinhua/deal'
  | 'zhajinhua/fold'
  | 'zhajinhua/showdown';
export type MusicTrack =
  | 'crash'
  | 'festive'
  | 'koi-pond'
  | 'lobby'
  | 'rounds'
  | 'slots'
  | 'teahouse';
export type AudioKey = SfxKey | `music/${MusicTrack}`;

export const AUDIO_ASSETS: Record<AudioKey, AudioAsset> = {
  'carp/gate': { ogg: '/audio/carp/gate.ogg?v=1108d947', m4a: '/audio/carp/gate.m4a?v=1108d947', durationMs: 2350, loop: false },
  'carp/jump': { ogg: '/audio/carp/jump.ogg?v=a48c9214', m4a: '/audio/carp/jump.m4a?v=a48c9214', durationMs: 320, loop: false },
  'carp/rock': { ogg: '/audio/carp/rock.ogg?v=f11bff8f', m4a: '/audio/carp/rock.m4a?v=f11bff8f', durationMs: 180, loop: false },
  'carp/splash': { ogg: '/audio/carp/splash.ogg?v=eab18fb6', m4a: '/audio/carp/splash.m4a?v=eab18fb6', durationMs: 420, loop: false },
  'common/achievement': { ogg: '/audio/common/achievement.ogg?v=a7234f69', m4a: '/audio/common/achievement.m4a?v=a7234f69', durationMs: 820, loop: false },
  'common/big': { ogg: '/audio/common/big.ogg?v=babf1383', m4a: '/audio/common/big.m4a?v=babf1383', durationMs: 1350, loop: false },
  'common/bonus-open': { ogg: '/audio/common/bonus-open.ogg?v=a3ad367f', m4a: '/audio/common/bonus-open.m4a?v=a3ad367f', durationMs: 720, loop: false },
  'common/boom': { ogg: '/audio/common/boom.ogg?v=9a16fb0b', m4a: '/audio/common/boom.m4a?v=9a16fb0b', durationMs: 480, loop: false },
  'common/click': { ogg: '/audio/common/click.ogg?v=c3b2dfbe', m4a: '/audio/common/click.m4a?v=c3b2dfbe', durationMs: 45, loop: false },
  'common/coin': { ogg: '/audio/common/coin.ogg?v=9073c087', m4a: '/audio/common/coin.m4a?v=9073c087', durationMs: 120, loop: false },
  'common/coins': { ogg: '/audio/common/coins.ogg?v=03a2ae17', m4a: '/audio/common/coins.m4a?v=03a2ae17', durationMs: 820, loop: false },
  'common/error': { ogg: '/audio/common/error.ogg?v=6a13fc0a', m4a: '/audio/common/error.m4a?v=6a13fc0a', durationMs: 190, loop: false },
  'common/flip': { ogg: '/audio/common/flip.ogg?v=9e3556d0', m4a: '/audio/common/flip.m4a?v=9e3556d0', durationMs: 140, loop: false },
  'common/level': { ogg: '/audio/common/level.ogg?v=ff865931', m4a: '/audio/common/level.m4a?v=ff865931', durationMs: 1000, loop: false },
  'common/mega': { ogg: '/audio/common/mega.ogg?v=f3a4717a', m4a: '/audio/common/mega.m4a?v=f3a4717a', durationMs: 2200, loop: false },
  'common/notify': { ogg: '/audio/common/notify.ogg?v=8cca60d3', m4a: '/audio/common/notify.m4a?v=8cca60d3', durationMs: 300, loop: false },
  'common/pop': { ogg: '/audio/common/pop.ogg?v=89fd1727', m4a: '/audio/common/pop.m4a?v=89fd1727', durationMs: 100, loop: false },
  'common/stop': { ogg: '/audio/common/stop.ogg?v=88231944', m4a: '/audio/common/stop.m4a?v=88231944', durationMs: 140, loop: false },
  'common/thud': { ogg: '/audio/common/thud.ogg?v=e767e900', m4a: '/audio/common/thud.m4a?v=e767e900', durationMs: 120, loop: false },
  'common/tick': { ogg: '/audio/common/tick.ogg?v=ba9a63d2', m4a: '/audio/common/tick.m4a?v=ba9a63d2', durationMs: 45, loop: false },
  'common/toggle': { ogg: '/audio/common/toggle.ogg?v=c8796c89', m4a: '/audio/common/toggle.m4a?v=c8796c89', durationMs: 65, loop: false },
  'common/win': { ogg: '/audio/common/win.ogg?v=3e7b8af4', m4a: '/audio/common/win.m4a?v=3e7b8af4', durationMs: 620, loop: false },
  'crash/cashout': { ogg: '/audio/crash/cashout.ogg?v=9b5435eb', m4a: '/audio/crash/cashout.m4a?v=9b5435eb', durationMs: 480, loop: false },
  'crash/crash': { ogg: '/audio/crash/crash.ogg?v=2fc50265', m4a: '/audio/crash/crash.m4a?v=2fc50265', durationMs: 450, loop: false },
  'crash/engine-loop': { ogg: '/audio/crash/engine-loop.ogg?v=a5711d80', m4a: '/audio/crash/engine-loop.m4a?v=a5711d80', durationMs: 3000, loop: true },
  'crash/launch': { ogg: '/audio/crash/launch.ogg?v=3200e642', m4a: '/audio/crash/launch.m4a?v=3200e642', durationMs: 480, loop: false },
  'deep/big-win': { ogg: '/audio/deep/big-win.ogg?v=4f33235a', m4a: '/audio/deep/big-win.m4a?v=4f33235a', durationMs: 1700, loop: false },
  'deep/cascade': { ogg: '/audio/deep/cascade.ogg?v=ee6101c8', m4a: '/audio/deep/cascade.m4a?v=ee6101c8', durationMs: 520, loop: false },
  'deep/reel-loop': { ogg: '/audio/deep/reel-loop.ogg?v=6958ba9f', m4a: '/audio/deep/reel-loop.m4a?v=6958ba9f', durationMs: 2000, loop: true },
  'deep/reel-stop-1': { ogg: '/audio/deep/reel-stop-1.ogg?v=dc3cc544', m4a: '/audio/deep/reel-stop-1.m4a?v=dc3cc544', durationMs: 130, loop: false },
  'deep/reel-stop-2': { ogg: '/audio/deep/reel-stop-2.ogg?v=0639176f', m4a: '/audio/deep/reel-stop-2.m4a?v=0639176f', durationMs: 145, loop: false },
  'deep/reel-stop-3': { ogg: '/audio/deep/reel-stop-3.ogg?v=bdfe5785', m4a: '/audio/deep/reel-stop-3.m4a?v=bdfe5785', durationMs: 160, loop: false },
  'deep/scatter': { ogg: '/audio/deep/scatter.ogg?v=4c378636', m4a: '/audio/deep/scatter.m4a?v=4c378636', durationMs: 450, loop: false },
  'deep/theme-stinger': { ogg: '/audio/deep/theme-stinger.ogg?v=1006d521', m4a: '/audio/deep/theme-stinger.m4a?v=1006d521', durationMs: 720, loop: false },
  'deep/win': { ogg: '/audio/deep/win.ogg?v=51acc015', m4a: '/audio/deep/win.m4a?v=51acc015', durationMs: 650, loop: false },
  'doudizhu/bomb': { ogg: '/audio/doudizhu/bomb.ogg?v=6a86aad5', m4a: '/audio/doudizhu/bomb.m4a?v=6a86aad5', durationMs: 460, loop: false },
  'doudizhu/deal': { ogg: '/audio/doudizhu/deal.ogg?v=ff50e073', m4a: '/audio/doudizhu/deal.m4a?v=ff50e073', durationMs: 520, loop: false },
  'doudizhu/pass': { ogg: '/audio/doudizhu/pass.ogg?v=e7e4d21e', m4a: '/audio/doudizhu/pass.m4a?v=e7e4d21e', durationMs: 180, loop: false },
  'doudizhu/play-cards': { ogg: '/audio/doudizhu/play-cards.ogg?v=8786acc0', m4a: '/audio/doudizhu/play-cards.m4a?v=8786acc0', durationMs: 230, loop: false },
  'doudizhu/rocket': { ogg: '/audio/doudizhu/rocket.ogg?v=3105f76a', m4a: '/audio/doudizhu/rocket.m4a?v=3105f76a', durationMs: 820, loop: false },
  'doudizhu/spring': { ogg: '/audio/doudizhu/spring.ogg?v=8f0b90af', m4a: '/audio/doudizhu/spring.m4a?v=8f0b90af', durationMs: 1200, loop: false },
  'firecrackers/cleared': { ogg: '/audio/firecrackers/cleared.ogg?v=efcf1dc3', m4a: '/audio/firecrackers/cleared.m4a?v=efcf1dc3', durationMs: 820, loop: false },
  'firecrackers/envelope-open': { ogg: '/audio/firecrackers/envelope-open.ogg?v=3ff7dfe2', m4a: '/audio/firecrackers/envelope-open.m4a?v=3ff7dfe2', durationMs: 480, loop: false },
  'firecrackers/firecracker': { ogg: '/audio/firecrackers/firecracker.ogg?v=918145ef', m4a: '/audio/firecrackers/firecracker.m4a?v=918145ef', durationMs: 560, loop: false },
  'firecrackers/ingot': { ogg: '/audio/firecrackers/ingot.ogg?v=b82fc00f', m4a: '/audio/firecrackers/ingot.m4a?v=b82fc00f', durationMs: 280, loop: false },
  'garden/big-win': { ogg: '/audio/garden/big-win.ogg?v=72036259', m4a: '/audio/garden/big-win.m4a?v=72036259', durationMs: 1700, loop: false },
  'garden/reel-loop': { ogg: '/audio/garden/reel-loop.ogg?v=ba0ba1e2', m4a: '/audio/garden/reel-loop.m4a?v=ba0ba1e2', durationMs: 2000, loop: true },
  'garden/reel-stop-1': { ogg: '/audio/garden/reel-stop-1.ogg?v=7332706a', m4a: '/audio/garden/reel-stop-1.m4a?v=7332706a', durationMs: 130, loop: false },
  'garden/reel-stop-2': { ogg: '/audio/garden/reel-stop-2.ogg?v=3b6d2558', m4a: '/audio/garden/reel-stop-2.m4a?v=3b6d2558', durationMs: 145, loop: false },
  'garden/reel-stop-3': { ogg: '/audio/garden/reel-stop-3.ogg?v=9442e81e', m4a: '/audio/garden/reel-stop-3.m4a?v=9442e81e', durationMs: 160, loop: false },
  'garden/scatter': { ogg: '/audio/garden/scatter.ogg?v=109db465', m4a: '/audio/garden/scatter.m4a?v=109db465', durationMs: 450, loop: false },
  'garden/theme-stinger': { ogg: '/audio/garden/theme-stinger.ogg?v=98ea1095', m4a: '/audio/garden/theme-stinger.m4a?v=98ea1095', durationMs: 620, loop: false },
  'garden/win': { ogg: '/audio/garden/win.ogg?v=51d6300c', m4a: '/audio/garden/win.m4a?v=51d6300c', durationMs: 650, loop: false },
  'hongbao/envelope-fly': { ogg: '/audio/hongbao/envelope-fly.ogg?v=e46ae65b', m4a: '/audio/hongbao/envelope-fly.m4a?v=e46ae65b', durationMs: 400, loop: false },
  'hongbao/envelope-open': { ogg: '/audio/hongbao/envelope-open.ogg?v=8ccf01ea', m4a: '/audio/hongbao/envelope-open.m4a?v=8ccf01ea', durationMs: 480, loop: false },
  'hongbao/luckiest': { ogg: '/audio/hongbao/luckiest.ogg?v=4a1636e0', m4a: '/audio/hongbao/luckiest.m4a?v=4a1636e0', durationMs: 820, loop: false },
  'koi-pond/big-win': { ogg: '/audio/koi-pond/big-win.ogg?v=e815b49e', m4a: '/audio/koi-pond/big-win.m4a?v=e815b49e', durationMs: 1700, loop: false },
  'koi-pond/koi-mult': { ogg: '/audio/koi-pond/koi-mult.ogg?v=f2733e33', m4a: '/audio/koi-pond/koi-mult.m4a?v=f2733e33', durationMs: 680, loop: false },
  'koi-pond/reel-loop': { ogg: '/audio/koi-pond/reel-loop.ogg?v=4bba5747', m4a: '/audio/koi-pond/reel-loop.m4a?v=4bba5747', durationMs: 2000, loop: true },
  'koi-pond/reel-stop-1': { ogg: '/audio/koi-pond/reel-stop-1.ogg?v=c0858650', m4a: '/audio/koi-pond/reel-stop-1.m4a?v=c0858650', durationMs: 130, loop: false },
  'koi-pond/reel-stop-2': { ogg: '/audio/koi-pond/reel-stop-2.ogg?v=fa017829', m4a: '/audio/koi-pond/reel-stop-2.m4a?v=fa017829', durationMs: 145, loop: false },
  'koi-pond/reel-stop-3': { ogg: '/audio/koi-pond/reel-stop-3.ogg?v=eff4692a', m4a: '/audio/koi-pond/reel-stop-3.m4a?v=eff4692a', durationMs: 160, loop: false },
  'koi-pond/scatter': { ogg: '/audio/koi-pond/scatter.ogg?v=8e05f591', m4a: '/audio/koi-pond/scatter.m4a?v=8e05f591', durationMs: 450, loop: false },
  'koi-pond/theme-stinger': { ogg: '/audio/koi-pond/theme-stinger.ogg?v=b9f4603e', m4a: '/audio/koi-pond/theme-stinger.m4a?v=b9f4603e', durationMs: 820, loop: false },
  'koi-pond/win': { ogg: '/audio/koi-pond/win.ogg?v=f9d51959', m4a: '/audio/koi-pond/win.m4a?v=f9d51959', durationMs: 650, loop: false },
  'mahjong-table/claim': { ogg: '/audio/mahjong-table/claim.ogg?v=68845750', m4a: '/audio/mahjong-table/claim.m4a?v=68845750', durationMs: 280, loop: false },
  'mahjong-table/discard': { ogg: '/audio/mahjong-table/discard.ogg?v=551fe2ce', m4a: '/audio/mahjong-table/discard.m4a?v=551fe2ce', durationMs: 200, loop: false },
  'mahjong-table/hu': { ogg: '/audio/mahjong-table/hu.ogg?v=8448f152', m4a: '/audio/mahjong-table/hu.m4a?v=8448f152', durationMs: 1550, loop: false },
  'mahjong-table/turn': { ogg: '/audio/mahjong-table/turn.ogg?v=328a0e76', m4a: '/audio/mahjong-table/turn.m4a?v=328a0e76', durationMs: 220, loop: false },
  'mahjong/hu': { ogg: '/audio/mahjong/hu.ogg?v=8448f152', m4a: '/audio/mahjong/hu.m4a?v=8448f152', durationMs: 1550, loop: false },
  'mahjong/shuffle': { ogg: '/audio/mahjong/shuffle.ogg?v=1ebdbf44', m4a: '/audio/mahjong/shuffle.m4a?v=1ebdbf44', durationMs: 950, loop: false },
  'mahjong/tile-click': { ogg: '/audio/mahjong/tile-click.ogg?v=a8990fec', m4a: '/audio/mahjong/tile-click.m4a?v=a8990fec', durationMs: 100, loop: false },
  'mahjong/tile-slide': { ogg: '/audio/mahjong/tile-slide.ogg?v=7b8d0bce', m4a: '/audio/mahjong/tile-slide.m4a?v=7b8d0bce', durationMs: 240, loop: false },
  'music/crash': { ogg: '/audio/music/crash.ogg?v=fc0d3fd6', m4a: '/audio/music/crash.m4a?v=fc0d3fd6', durationMs: 90353, loop: true },
  'music/festive': { ogg: '/audio/music/festive.ogg?v=9b71253e', m4a: '/audio/music/festive.m4a?v=9b71253e', durationMs: 76800, loop: true },
  'music/koi-pond': { ogg: '/audio/music/koi-pond.ogg?v=adbd6d00', m4a: '/audio/music/koi-pond.m4a?v=adbd6d00', durationMs: 96000, loop: true },
  'music/lobby': { ogg: '/audio/music/lobby.ogg?v=c82e15a2', m4a: '/audio/music/lobby.m4a?v=c82e15a2', durationMs: 80000, loop: true },
  'music/rounds': { ogg: '/audio/music/rounds.ogg?v=9ad44ea6', m4a: '/audio/music/rounds.m4a?v=9ad44ea6', durationMs: 80000, loop: true },
  'music/slots': { ogg: '/audio/music/slots.ogg?v=cd4c2c39', m4a: '/audio/music/slots.m4a?v=cd4c2c39', durationMs: 80000, loop: true },
  'music/teahouse': { ogg: '/audio/music/teahouse.ogg?v=67163730', m4a: '/audio/music/teahouse.m4a?v=67163730', durationMs: 101053, loop: true },
  'pot/wheel-stop': { ogg: '/audio/pot/wheel-stop.ogg?v=ee65d8eb', m4a: '/audio/pot/wheel-stop.m4a?v=ee65d8eb', durationMs: 180, loop: false },
  'pot/wheel-tick': { ogg: '/audio/pot/wheel-tick.ogg?v=4b88d613', m4a: '/audio/pot/wheel-tick.m4a?v=4b88d613', durationMs: 75, loop: false },
  'pot/winner': { ogg: '/audio/pot/winner.ogg?v=3566e4c0', m4a: '/audio/pot/winner.m4a?v=3566e4c0', durationMs: 680, loop: false },
  'roulette/green': { ogg: '/audio/roulette/green.ogg?v=a98fddc5', m4a: '/audio/roulette/green.m4a?v=a98fddc5', durationMs: 380, loop: false },
  'roulette/strip-loop': { ogg: '/audio/roulette/strip-loop.ogg?v=c0b3a994', m4a: '/audio/roulette/strip-loop.m4a?v=c0b3a994', durationMs: 1500, loop: true },
  'roulette/strip-stop': { ogg: '/audio/roulette/strip-stop.ogg?v=f2e444d1', m4a: '/audio/roulette/strip-stop.m4a?v=f2e444d1', durationMs: 180, loop: false },
  'slots/feature-end': { ogg: '/audio/slots/feature-end.ogg?v=0eede5fa', m4a: '/audio/slots/feature-end.m4a?v=0eede5fa', durationMs: 850, loop: false },
  'slots/freespins': { ogg: '/audio/slots/freespins.ogg?v=67b6c7b0', m4a: '/audio/slots/freespins.m4a?v=67b6c7b0', durationMs: 900, loop: false },
  'slots/reel-loop': { ogg: '/audio/slots/reel-loop.ogg?v=c580e03b', m4a: '/audio/slots/reel-loop.m4a?v=c580e03b', durationMs: 2000, loop: true },
  'slots/reel-stop-1': { ogg: '/audio/slots/reel-stop-1.ogg?v=6e62bea7', m4a: '/audio/slots/reel-stop-1.m4a?v=6e62bea7', durationMs: 180, loop: false },
  'slots/reel-stop-2': { ogg: '/audio/slots/reel-stop-2.ogg?v=249ab68a', m4a: '/audio/slots/reel-stop-2.m4a?v=249ab68a', durationMs: 200, loop: false },
  'slots/reel-stop-3': { ogg: '/audio/slots/reel-stop-3.ogg?v=318a9710', m4a: '/audio/slots/reel-stop-3.m4a?v=318a9710', durationMs: 220, loop: false },
  'slots/scatter': { ogg: '/audio/slots/scatter.ogg?v=de50f6fd', m4a: '/audio/slots/scatter.m4a?v=de50f6fd', durationMs: 480, loop: false },
  'spaceport/big-win': { ogg: '/audio/spaceport/big-win.ogg?v=94b2900d', m4a: '/audio/spaceport/big-win.m4a?v=94b2900d', durationMs: 1700, loop: false },
  'spaceport/bonus-buy': { ogg: '/audio/spaceport/bonus-buy.ogg?v=450cfd6d', m4a: '/audio/spaceport/bonus-buy.m4a?v=450cfd6d', durationMs: 720, loop: false },
  'spaceport/reel-loop': { ogg: '/audio/spaceport/reel-loop.ogg?v=1abfd399', m4a: '/audio/spaceport/reel-loop.m4a?v=1abfd399', durationMs: 2000, loop: true },
  'spaceport/reel-stop-1': { ogg: '/audio/spaceport/reel-stop-1.ogg?v=5059c804', m4a: '/audio/spaceport/reel-stop-1.m4a?v=5059c804', durationMs: 130, loop: false },
  'spaceport/reel-stop-2': { ogg: '/audio/spaceport/reel-stop-2.ogg?v=ba54055c', m4a: '/audio/spaceport/reel-stop-2.m4a?v=ba54055c', durationMs: 145, loop: false },
  'spaceport/reel-stop-3': { ogg: '/audio/spaceport/reel-stop-3.ogg?v=964f767c', m4a: '/audio/spaceport/reel-stop-3.m4a?v=964f767c', durationMs: 160, loop: false },
  'spaceport/scatter': { ogg: '/audio/spaceport/scatter.ogg?v=4f418cf2', m4a: '/audio/spaceport/scatter.m4a?v=4f418cf2', durationMs: 450, loop: false },
  'spaceport/theme-stinger': { ogg: '/audio/spaceport/theme-stinger.ogg?v=9d0a180e', m4a: '/audio/spaceport/theme-stinger.m4a?v=9d0a180e', durationMs: 680, loop: false },
  'spaceport/win': { ogg: '/audio/spaceport/win.ogg?v=c0940ef6', m4a: '/audio/spaceport/win.m4a?v=c0940ef6', durationMs: 650, loop: false },
  'sweet-shop/big-win': { ogg: '/audio/sweet-shop/big-win.ogg?v=fa320679', m4a: '/audio/sweet-shop/big-win.m4a?v=fa320679', durationMs: 1700, loop: false },
  'sweet-shop/jackpot-grand': { ogg: '/audio/sweet-shop/jackpot-grand.ogg?v=f3a4717a', m4a: '/audio/sweet-shop/jackpot-grand.m4a?v=f3a4717a', durationMs: 2200, loop: false },
  'sweet-shop/jackpot-major': { ogg: '/audio/sweet-shop/jackpot-major.ogg?v=fc764aaa', m4a: '/audio/sweet-shop/jackpot-major.m4a?v=fc764aaa', durationMs: 1250, loop: false },
  'sweet-shop/jackpot-mini': { ogg: '/audio/sweet-shop/jackpot-mini.ogg?v=e24cde84', m4a: '/audio/sweet-shop/jackpot-mini.m4a?v=e24cde84', durationMs: 750, loop: false },
  'sweet-shop/jar': { ogg: '/audio/sweet-shop/jar.ogg?v=29743d7e', m4a: '/audio/sweet-shop/jar.m4a?v=29743d7e', durationMs: 620, loop: false },
  'sweet-shop/reel-loop': { ogg: '/audio/sweet-shop/reel-loop.ogg?v=24ea5ddf', m4a: '/audio/sweet-shop/reel-loop.m4a?v=24ea5ddf', durationMs: 2000, loop: true },
  'sweet-shop/reel-stop-1': { ogg: '/audio/sweet-shop/reel-stop-1.ogg?v=01806faf', m4a: '/audio/sweet-shop/reel-stop-1.m4a?v=01806faf', durationMs: 130, loop: false },
  'sweet-shop/reel-stop-2': { ogg: '/audio/sweet-shop/reel-stop-2.ogg?v=5cb9e13e', m4a: '/audio/sweet-shop/reel-stop-2.m4a?v=5cb9e13e', durationMs: 145, loop: false },
  'sweet-shop/reel-stop-3': { ogg: '/audio/sweet-shop/reel-stop-3.ogg?v=44f2ff1b', m4a: '/audio/sweet-shop/reel-stop-3.m4a?v=44f2ff1b', durationMs: 160, loop: false },
  'sweet-shop/scatter': { ogg: '/audio/sweet-shop/scatter.ogg?v=d96da10e', m4a: '/audio/sweet-shop/scatter.m4a?v=d96da10e', durationMs: 450, loop: false },
  'sweet-shop/theme-stinger': { ogg: '/audio/sweet-shop/theme-stinger.ogg?v=5e9a5212', m4a: '/audio/sweet-shop/theme-stinger.m4a?v=5e9a5212', durationMs: 620, loop: false },
  'sweet-shop/win': { ogg: '/audio/sweet-shop/win.ogg?v=1edc95e8', m4a: '/audio/sweet-shop/win.m4a?v=1edc95e8', durationMs: 650, loop: false },
  'tourney/seat-ready': { ogg: '/audio/tourney/seat-ready.ogg?v=9d919e2d', m4a: '/audio/tourney/seat-ready.m4a?v=9d919e2d', durationMs: 340, loop: false },
  'tourney/stage-up': { ogg: '/audio/tourney/stage-up.ogg?v=1fa9ddc4', m4a: '/audio/tourney/stage-up.m4a?v=1fa9ddc4', durationMs: 720, loop: false },
  'workshop/big-win': { ogg: '/audio/workshop/big-win.ogg?v=573c6d9c', m4a: '/audio/workshop/big-win.m4a?v=573c6d9c', durationMs: 1700, loop: false },
  'workshop/progress': { ogg: '/audio/workshop/progress.ogg?v=560b1d45', m4a: '/audio/workshop/progress.m4a?v=560b1d45', durationMs: 450, loop: false },
  'workshop/reel-loop': { ogg: '/audio/workshop/reel-loop.ogg?v=27f3d2f7', m4a: '/audio/workshop/reel-loop.m4a?v=27f3d2f7', durationMs: 2000, loop: true },
  'workshop/reel-stop-1': { ogg: '/audio/workshop/reel-stop-1.ogg?v=0f17369e', m4a: '/audio/workshop/reel-stop-1.m4a?v=0f17369e', durationMs: 130, loop: false },
  'workshop/reel-stop-2': { ogg: '/audio/workshop/reel-stop-2.ogg?v=4f51fd03', m4a: '/audio/workshop/reel-stop-2.m4a?v=4f51fd03', durationMs: 145, loop: false },
  'workshop/reel-stop-3': { ogg: '/audio/workshop/reel-stop-3.ogg?v=d5afd342', m4a: '/audio/workshop/reel-stop-3.m4a?v=d5afd342', durationMs: 160, loop: false },
  'workshop/scatter': { ogg: '/audio/workshop/scatter.ogg?v=13bf5c95', m4a: '/audio/workshop/scatter.m4a?v=13bf5c95', durationMs: 450, loop: false },
  'workshop/theme-stinger': { ogg: '/audio/workshop/theme-stinger.ogg?v=3c6bd2d2', m4a: '/audio/workshop/theme-stinger.m4a?v=3c6bd2d2', durationMs: 720, loop: false },
  'workshop/win': { ogg: '/audio/workshop/win.ogg?v=2183eecc', m4a: '/audio/workshop/win.m4a?v=2183eecc', durationMs: 650, loop: false },
  'zhajinhua/card-flip': { ogg: '/audio/zhajinhua/card-flip.ogg?v=cab9c124', m4a: '/audio/zhajinhua/card-flip.m4a?v=cab9c124', durationMs: 180, loop: false },
  'zhajinhua/deal': { ogg: '/audio/zhajinhua/deal.ogg?v=4c596ca1', m4a: '/audio/zhajinhua/deal.m4a?v=4c596ca1', durationMs: 520, loop: false },
  'zhajinhua/fold': { ogg: '/audio/zhajinhua/fold.ogg?v=499535e0', m4a: '/audio/zhajinhua/fold.m4a?v=499535e0', durationMs: 200, loop: false },
  'zhajinhua/showdown': { ogg: '/audio/zhajinhua/showdown.ogg?v=f04a07fe', m4a: '/audio/zhajinhua/showdown.m4a?v=f04a07fe', durationMs: 1350, loop: false },
};
